import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Perspective = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 18C25.913 18 25.812 18 25.725 18.012L24.175 13.362C25.275 12.649 26 11.412 26 10.012C26 7.81202 24.2 6.01202 22 6.01202C20.137 6.01202 18.575 7.28702 18.125 9.01202H13.875C13.425 7.28702 11.863 6.01202 10 6.01202C7.8 6.01202 6 7.81202 6 10.012C6 11.412 6.725 12.649 7.825 13.362L6.275 18.012C6.187 18.012 6.087 18 6 18C3.8 18 2 19.8 2 22C2 24.2 3.8 26 6 26C7.862 26 9.425 24.725 9.875 23H22.125C22.575 24.725 24.137 26 26 26C28.2 26 30 24.2 30 22C30 19.8 28.2 18 26 18ZM22 8.00002C23.1 8.00002 24 8.90002 24 10C24 11.1 23.1 12 22 12C20.9 12 20 11.1 20 10C20 8.90002 20.9 8.00002 22 8.00002ZM10 8.00002C11.1 8.00002 12 8.90002 12 10C12 11.1 11.1 12 10 12C8.9 12 8 11.1 8 10C8 8.90002 8.9 8.00002 10 8.00002ZM6 24C4.9 24 4 23.1 4 22C4 20.9 4.9 20 6 20C7.1 20 8 20.9 8 22C8 23.1 7.1 24 6 24ZM22.125 21H9.875C9.625 20.012 9 19.187 8.175 18.65L9.725 14C9.813 14 9.913 14.012 10 14.012C11.863 14.012 13.425 12.737 13.875 11.012H18.125C18.575 12.737 20.137 14.012 22 14.012C22.087 14.012 22.188 14.012 22.275 14L23.825 18.65C23 19.188 22.375 20.013 22.125 21ZM26 24C24.9 24 24 23.1 24 22C24 20.9 24.9 20 26 20C27.1 20 28 20.9 28 22C28 23.1 27.1 24 26 24Z" />
	</svg>
);

export default Perspective;
